import { render, staticRenderFns } from "./InvoicesInfo.vue?vue&type=template&id=266da808"
import script from "./InvoicesInfo.vue?vue&type=script&lang=js"
export * from "./InvoicesInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports